import {Results} from 'common/models/success';

import {RootState} from '../..';

const selectIntegrations: (state: RootState) => Results = (state) => {
    if (!state.success.results) {
        return {
            data: [],
        };
    }
    return {
        ...state.success.results,
        data: state.success.results.data.filter((item) => typeof item.scores !== 'undefined'),
    };
};

export default selectIntegrations;
